import {
  CommonIncidentId,
  EmergencyIncidentId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

/**
 * Incidents that can occur after a Serve which hold disabled Serve.
 *
 * These incidents are considered part of the Serve continuation and do not end the Serve sequence.
 *
 * In other words, every other incident (except Reception) should 'unlock' possibility to Serve again.
 */
const serveContinuationIncidents = new Set<
  VolleyballIncidentId | CommonIncidentId | EmergencyIncidentId
>([
  VolleyballIncidentId.Challenge,
  VolleyballIncidentId.SetBall,
  VolleyballIncidentId.MatchBall,
  VolleyballIncidentId.SetWon,
  VolleyballIncidentId.Cards,
  VolleyballIncidentId.Set,
  VolleyballIncidentId.NeutralAttack,
  VolleyballIncidentId.Dig,
  VolleyballIncidentId.Timeout,
  VolleyballIncidentId.TimeoutOver,
  VolleyballIncidentId.RefereeChallenge,
  VolleyballIncidentId.PlayerChangeSides,
  VolleyballIncidentId.BreakDuringTheGame,
  CommonIncidentId.TechnicalProblems,
  CommonIncidentId.MatchResumed,
  CommonIncidentId.Betstart,
  CommonIncidentId.Betstop,
  EmergencyIncidentId.MatchWillNotBeCovered,
  EmergencyIncidentId.ProblemsWithSourceOfBroadcast,
  EmergencyIncidentId.ProblemWithSourceOfBroadcastSolved,
  EmergencyIncidentId.ScoutingCoverageCanStartWithDelay,
  EmergencyIncidentId.ExpectedDelayInStartOfMatch,
  EmergencyIncidentId.TeamLineupsWillNotBeAvailable,
  EmergencyIncidentId.SourceOfCoverageDelayed,
  EmergencyIncidentId.CurrentPartOfGameHasStartedWithDelay,
  EmergencyIncidentId.VerificationOfResultInProgress,
  EmergencyIncidentId.VerificationOfResultCompletedAndCorrect,
  EmergencyIncidentId.VerificationOfKeyStatisticsInProgress,
  EmergencyIncidentId.VerificationOfKeyStatisticsCompletedAndCorrect,
  EmergencyIncidentId.VerificationOfGameClockInProgress,
  EmergencyIncidentId.VerificationOfGameClockCompletedAndCorrect,
  EmergencyIncidentId.MatchCoverageInterruptedDueToTechnicalIssues,
  EmergencyIncidentId.MatchCoverageWillContinue,
  EmergencyIncidentId.MatchCoverageWillNotContinue,
  EmergencyIncidentId.MatchIsAbandoned,
  EmergencyIncidentId.WaitingForOfficialDecisionRegardingMatchResumption,
  EmergencyIncidentId.MatchWillResumeShortly,
  EmergencyIncidentId.MatchWillNotResume,
  EmergencyIncidentId.ExpectedDelayInStartOfNextPartOfGame,
  EmergencyIncidentId.ChangeOfCoverageFromVenueToTv,
  EmergencyIncidentId.ChangeOfCoverageFromTvToVenue,
  EmergencyIncidentId.ChangeOfCoverageLatency,
  EmergencyIncidentId.ExpectedDelayInStartOfMatchSafetyReasons,
  EmergencyIncidentId.VerificationOfPlayerNamesForKeyIncidentsInProgress,
  EmergencyIncidentId.VerificationOfPlayerNamesForKeyIncidentsCompletedAndCorrect,
  EmergencyIncidentId.ProblemsWithLowLatencySourceOfCoverage,
  EmergencyIncidentId.ProblemsWithLowLatencySourceOfCoverageSolved,
  EmergencyIncidentId.PlayerNameVerificationInProgressSubstitution,
])

function isServeContinuationIncident(
  incidentId: VolleyballIncidentId,
): boolean {
  return serveContinuationIncidents.has(incidentId)
}

export function isServeHandler(incidentId: VolleyballIncidentId): boolean {
  return (
    !isServeContinuationIncident(incidentId) &&
    incidentId !== VolleyballIncidentId.Reception
  )
}

export function isReceptionHandler(incidentId: VolleyballIncidentId): boolean {
  return !isServeContinuationIncident(incidentId)
}
